module.exports = __webpack_public_path__ + "static/media/RP-A_S_Fashion_Roseto Sand_DK Grey.b2d93b49.png";